<template>
  <div class="asset__select">
      <select :value="value" @change="setValue($event.target.value)">
      <option :selected="asset.id === value" v-for="asset in assets" :key="asset.id" :value="asset.id" >{{asset.title}}</option>
    </select>
  </div>
</template>

<script>

export default {
  name: "assetSelect",
  props: ["value", "assets"],
  methods: {
    setValue(value) {
      console.log('onAssetSelect', value)
      this.$emit("input", value);
    }
  }
};
</script>
